// @flow
import * as React from 'react';
import {CliConnection} from '../helpers/commands/listen';
import {tree} from '../generated_tree';

const command = tree.root.commands?.stripe.commands?.listen;
const path = command?.path || '/v1/stripecli/sessions';
const method = command?.method || 'post';

// / Function that handles listen
export function listen({
  args,
  params,
  apiKey,
  setAllowInput,
}: {
  args: Array<string>,
  params: {[string]: string},
  apiKey: string,
  setAllowInput: (boolean) => void,
}): React.Node {
  // Verify number of arguments.
  if (args.length > 0) {
    setAllowInput(true);
    return `This command does not expect any arguments. Given: ${args.join(
      ', ',
    )}`;
  }

  return (
    <CliConnection
      path={path}
      method={method}
      params={params}
      api_key={apiKey}
      setAllowInput={setAllowInput}
    />
  );
}
